import Modal from "./base.modal";
import Button from "../ui/button";
import type { ModalComponentProps } from "../../types/modal.types";

interface DialogProps extends ModalComponentProps {
  title: string;
  content: string;
  enableOutsideClick?: boolean;
}

export default function AlertDialog(props: DialogProps) {
  const { onClose, title, content, enableOutsideClick = true } = props;

  return (
    <Modal className="p-4 pt-6" size="dialog" close={onClose} enableOutsideClick={enableOutsideClick}>
      <section className="w-full">
        <p className="text-style-body-05 font-normal">{title}</p>
        <p className="text-style-body-03 font-normal text-gray-50 whitespace-pre-line">{content}</p>
      </section>

      <section className="w-full gap-4 mt-7">
        <Button
          variant={"primary"}
          className="float-right"
          label="확인"
          onClick={onClose}
        />
      </section>
    </Modal>
  );
};
